import { createFileRoute } from "@tanstack/react-router";
import { getCliCompletion } from "@/features/identity/records";
import { cliCompleteSearchSchema } from "@/features/identity/navigation";
import { CliAuthError, CliAuthCompleteClient } from "@/features/identity";

export const Route = createFileRoute("/_site/cli-auth/complete")({
  validateSearch: cliCompleteSearchSchema,
  loaderDeps: ({ search }) => ({ callback: search.callback }),
  loader: ({ deps, abortController }) =>
    getCliCompletion({ data: deps, signal: abortController.signal }),
  gcTime: 0,
  head: () => ({
    meta: [
      { title: "Complete Softmax CLI sign-in" },
      { name: "robots", content: "noindex, nofollow" },
      { name: "referrer", content: "no-referrer" },
    ],
  }),
  component: CliAuthCompleteRoute,
});

function CliAuthCompleteRoute() {
  const { code } = Route.useSearch();
  const { callback, hasInvalidCallback, loginServer } = Route.useLoaderData();

  if (!code) return <CliAuthError kind="missing-code" />;

  if (hasInvalidCallback) return <CliAuthError kind="callback" />;

  return (
    <div className="min-h-screen bg-[#fffdf4] text-[#0e2758]">
      <main id="main" className="flex flex-col items-center px-4 py-16">
        <div className="w-full max-w-2xl">
          <CliAuthCompleteClient
            key={`${code}:${callback}`}
            callback={callback}
            loginServer={loginServer}
            code={code}
          />
        </div>
      </main>
    </div>
  );
}
